module.exports = {
  TheNotYourCustomerSelect: '该委托单位不属于您的客户，请重新选择！',
  YourAuthorityIsInsufficient: '你的权限不够。',
  SailingSchedule2: '船期2:',
  Voyage: '航程:',
  OverweightDescription: '超重说明:',
  LowestPrice: '最低价',
  SailingSchedule: '船期:',
  FullContainerFreightSharingDetails: '整箱运价分享详情',
  FullContainerFCLFreight: '整箱(FCL)运价',
  LessContainerLoadLCLFreight: '拼箱(LCL)运价',
  AirCargoAIRFreight: '空运(AIR)运价',
  All: '全部',
  Code: '代码',
  ChineseName: '中文名',
  EnglishName: '英文名',
  Country: '国家',
  Region: '区域',
  AirFreightSurchargeDetails: '空运附加费详情',
  Empty: '空',
  LCLDestinationPortChargesDetails: '拼箱目的港收费详情',
  AirCargoRateDetails: '空运运价详情',
  SecondTransit: '中转二',
  SecondLegAircraftType: '二程机型',
  SecondLegFlightSchedule: '二程航班时刻',
  SecondScheduleCannotBeEmpty: '二程航班时刻不能为空.',
  ProgramSettings: '方案设置',
  FullContainerFreightDetails: '整箱运价详情',
  EuropeAndAmericaLinesDedicated: '欧美线专用',
  EmailCannotBeEmpty: '邮箱不能为空',
  EmailFormatError: '邮箱格式错误',
  DestinationAreaError: '目的区域有误！',
  ContinueImporting: ',是否继续导入？',
  FullContainerAddonFreightDetails: '整箱Addon运价详情',
  FullContainerAdditionalInformationDetails: '整箱附加信息详情',
  LCLFreightDetails: '拼箱运价详情',
  CostPrice: '成本价',
  PeerPrice: '同行价',
  DirectCustomerPrice: '直客价',
  MarketPrice: '市场价',
  LCLAddonFreightDetails: '拼箱Addon运价详情',
  YourPermissionIsNotEnough: '你的权限不够。',
  SailingTime: '航程:',
  FCL: '整箱',
  LCL: '拼箱',
  FreightNumber: '运价号:',
  CabinStatus: '舱位状态:',
  OurDumpingOfContainersOK: '我司不能保证预配ok情况下不甩箱',
  NoteAdditionalChargesWithBackground: '备注：ALL IN 价已包含附加费中灰色背景的费用项。',
  Booking: '订舱',
  ThisFareHasExpired: '此运价已过期!',
  NoFreightThatMeetsParty: '运价有效期内找不到符合船期要求的开航日期,请与订舱方沟通确认!',
  Subscribe: '订阅',
  SetEmailToReceiveInformation: '设置您要接收订阅信息的邮箱',
  TheEmailCannotBeEmpty: '邮箱不能为空',
  SetCompanyToReceiveInformation: '设置您要接收订阅信息的（分）公司',
  SetYouWantToTo: '设置您需要订阅的合作伙伴',
  AdvancedSettings: '高级设置',
  SubscriptionType: '订阅类型',
  PlaceOfDeparture: '起运地',
  DischargePort: '卸货地',
  Airline: '航空公司',
  ShippingCompany: '船公司',
  Confirm: '确定',
  Reset: '重置',
  Refresh: '刷新',
  Cancel: '取消',
  PleaseYouWillReceiveUpdated: '请订阅你感兴趣的信息，当运价更新后您将收到提醒邮件。',
  Add: '新增',
  Edit: '编辑',
  Delete: '删除',
  GoBack: '返回',
  Save: '保存',
  SubCompany: '分公司',
  DeparturePort: '起运港',
  DepartureCountry: '起运国家',
  DepartureArea: '起运区域',
  DestinationPort: '目的港',
  DestinationCountryRegion: '目的国家(地区)',
  DestinationArea: '目的区域',
  FCLWeightLimitInformationDetails: '整箱限重信息详情',
  PleaseTheEntrustedContainerVolume: '请录入委托箱量!',
  TheBelongToYourSelect: '该委托单位不属于您的客户，请重新选择！',
  ExternalUser: '外部用户',
  FCLSailingScheduleManagement: '整箱船期管理',
  ConfigSurchargeFcl: '配置附加费',
  FCLAdditionalFeeMaintenance: '整箱附加费维护',
  HsCode: 'HSCODE',
  UnNo: 'UN nbr'
}
